export default {
  namespaced: true,
  state: {
    organizationData: []
  },
  mutations: {
    SET_ORG_DATA(state, organizationData) {
      state.organizationData = organizationData
    }
  }
}
